import { render, staticRenderFns } from "./ApplianceModelInfo.vue?vue&type=template&id=4bdf8fd6"
import script from "./ApplianceModelInfo.vue?vue&type=script&lang=js"
export * from "./ApplianceModelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports